import IconNameEnum from "constants/IconNameEnum";
import React from "react";
import BaseBadge from "./BaseBadge";

interface IProps {
    icon: IconNameEnum;
    className?: string;
    color?: "default" | "white" | "e" | "s";
    badge?: string | number;
    hoverTitle?: string;
    rotate?: boolean;
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    height?: string;
    width?: string;
    style?: React.CSSProperties;
}

class BaseIcon extends React.Component<IProps> {
    private handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        const { onClick } = this.props;
        onClick && onClick(event);
    };
    public render(): JSX.Element {
        const { icon, className, color, badge, hoverTitle, rotate, style } = this.props;
        const iconName =
            color === "white"
                ? `${icon} b`
                : color === "default" || color === undefined
                ? `${icon}`
                : `${icon}_${color}`;

        return (
            <>
                <img
                    style={{ ...style, height: this.props.height, width: this.props.width }}
                    className={["align-self-center ocq-icon", rotate ? "rotated" : "", className].join(" ")}
                    alt="icon"
                    src={require(`assets/icons/${iconName}.svg`)}
                    title={hoverTitle}
                    color={color}
                    onClick={this.handleOnClick}
                />
                <BaseBadge content={badge} />
            </>
        );
    }
}

export { BaseIcon as Unconnected };
export default BaseIcon;
